export default {
  // ownurl: "http://localhost:8080/",
  // defurl: "http://localhost:8080/",
  // rooturl: "http://localhost:8080/",

  ownurl: "https://api.edtp.pertamina.com/",
  defurl: "https://api.edtp.pertamina.com/",
  rooturl: "https://api.edtp.pertamina.com/",

  apikey: "Token ",
  payloadEncryptionPublicKey:
    process.env.REACT_APP_EDTPV3_PAYLOAD_PUBLIC_KEY ||
    process.env.REACT_APP_PAYLOAD_PUBLIC_KEY ||
    ""
};
